import React from "react";
import type { OrderItem } from "../OrderItemRow";
import OrderItemRow from "../OrderItemRow";
import { ShoppingCart } from "lucide-react";

interface OrderPanelProps {
  items: OrderItem[];
  onQuantityChange: (id: string, qty: number) => void;
  onRemove: (id: string) => void;
  onCheckout: (total: number) => void;
}

const OrderPanel: React.FC<OrderPanelProps> = ({
  items,
  onQuantityChange,
  onRemove,
  onCheckout,
}) => {
  const total = items.reduce((sum, item) => sum + item.selling_price * item.quantity, 0);

  return (
    <div className="lg:w-2/4 bg-white rounded-lg shadow-md p-4 flex flex-col justify-between">
      <div>
        <h3 className="text-lg font-semibold mb-3">🛒 Current Order</h3>
        {items.length ? (
          <div className="max-h-80 overflow-y-auto divide-y">
            {items.map((item) => (
              <OrderItemRow
                key={item.id}
                item={item}
                onQuantityChange={onQuantityChange}
                onRemove={onRemove}
              />
            ))}
          </div>
        ) : (
          <p className="text-gray-400 italic text-center py-10">
            No items added yet.
          </p>
        )}
      </div>

      {items.length > 0 && (
        <div className="mt-4 border-t pt-3 flex justify-between items-center">
          <span className="font-semibold text-gray-700">Total:</span>
          <span className="text-xl font-bold text-blue-700">₵{total}</span>
        </div>
      )}

      <button
        className="mt-4 px-3 py-2 text-sm bg-primary text-white rounded-md hover:bg-blue-900 flex gap-2 items-center justify-center disabled:bg-gray-300"
        disabled={!items.length}
        onClick={() => onCheckout(total)}
      >
        <ShoppingCart size={12}/>
        Process
      </button>
    </div>
  );
};

export default OrderPanel;
